import { css } from '@emotion/core';
import MediaQueries from '../../../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../../../styles/typography';
import { colorsPalette } from '../../../../../styles/colors';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../../utils/constants';

const headerFont = css(typography.effra28, {
  fontWeight: fontWeights.medium,
  [MediaQueries.mdAndUp]: {
    ...typography.effra40,
    fontWeight: fontWeights.medium,
  },
});

export const introContentWrapper = css({
  height: `calc(100vh - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [MediaQueries.mdAndUp]: {
    height: `calc(100vh - ${NAV_MAX_HEIGHT}px)`,
  },
});

// Needs explicit width: 100% to fix issue on ie 11 related to flex parent
export const introContentRow = css({
  width: '100%',
});

export const headline = css(headerFont, {
  color: colorsPalette.black,
  marginBottom: 16,
  [MediaQueries.md]: {
    marginBottom: 24,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 32,
  },
});
export const bodyText = css(typography.effra18, {
  marginBottom: 32,
  [MediaQueries.md]: {
    marginBottom: 40,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 56,
  },
});
